import React from 'react';
import EnhancedTree from '../../../components/enhanced-tree';
import { compose } from 'redux';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { createCubeBackup, deleteBackupCube, getAllCubeBackupOrRestoreUrl, getRestoreCube, seletedCubeBackupOrRestore } from './actions';
import Call from '../../../hocs/call';
import { getLocalizedStr } from '../../../middlewares/i18n/utils';
import { getNodes } from '../../../utils/tree';
import { Button, Row } from 'antd';
import { IconCube, IconCubeAndBackup } from './components/IconsBackup';


const mapStateToProps = state => ({
    appLanguage: state.app.language,
    dataLanguages: state.config.dataManagement.dataLanguages,
    cubeList: state.scenes.utilities.cubeBackupRestore.cubeList,
    selectedCube: state.scenes.utilities.cubeBackupRestore.selectedCube,
})


const mapDispatchToProps = dispatch => ({
    onFetchCubes: () => dispatch(getAllCubeBackupOrRestoreUrl()),
    onSelectedCube: (cube)=> dispatch(seletedCubeBackupOrRestore(cube)),
    onCreateBackupCube: (cubeId) => dispatch(createCubeBackup(cubeId)),
    onRestoreCube:(cubeId)=> dispatch(getRestoreCube(cubeId)),
    onDeleteBackupCube:(cubeId) => dispatch(deleteBackupCube(cubeId))
})


const BackupRestoreCube = ({
    t,
    appLanguage,
    dataLanguages,
    cubeList,
    onFetchCubes,
    onSelectedCube,
    selectedCube,
    onCreateBackupCube,
    onRestoreCube,
    onDeleteBackupCube
}) => {


const cube = React.useMemo(()=>{return selectedCube },[selectedCube])

return (
        <React.Fragment>
            <Call cb={onFetchCubes} disabled={!!cubeList}>
               {!!cubeList && 
               <EnhancedTree
                className="ant-row-flex custom-tree__tree-header_p"
                style={{paddingTop:'20px'}}
                tree={cubeList}
                idKey="TreeID"
                nameKey="labels"
                childrenKey="children"
                catIdKey="TreeID"
                catNameKey="labels"
                getIsNameMultilanguage={node => node.Code}
                defaultExpandAll
                unselectableKeys={
                    getNodes(cubeList, 'children', (({Code}) => !Code ))
                      .map(node => node.TreeID)
                }
                hiddenIdKeys={
                    getNodes(cubeList, 'children', (({Code, IDCat}) => !Code && !IDCat))
                      .map(node => node.TreeID)
                  }
                getIcon={({Code, HasBackup}) => {                   
                        if(Code && HasBackup === true){
                            return(<IconCubeAndBackup />)
                        }
                        if(Code){
                            return (<IconCube/>);
                        }
                        else{
                            return null;
                        }
                    }
                }
                onSelect={selectedArr =>  
                    onSelectedCube(
                    ...getNodes(cubeList, 'children',(({Code}) => Code === selectedArr[0]))
                    ) 
                } 
                getFilter={
                    searchText =>
                      ({labels, Code, Name}) => {
                        const search = searchText.toLowerCase();
                        return (Name && Name.toLowerCase()
                            .indexOf(search) >= 0) ||
                          (Code && Code.toLowerCase()
                            .indexOf(search) >= 0) ||
                          (labels && getLocalizedStr(labels, appLanguage, dataLanguages)
                            .toLowerCase()
                            .indexOf(search) >= 0);
                      }
                  }
                leftActions={<Row type="flex" style={{gap:10}}>
                    <Button.Group>
                        <Button 
                            title={t('scenes.utilities.cubeBackupRestore.buttons.backup')}
                            style={{padding:'0px 8px'}}
                            icon='plus'
                            disabled={!cube || !!cube.HasBackup || cube.IDCube === undefined}
                            onClick={()=> !!cube && onCreateBackupCube(cube.IDCube)}>
                        </Button>
                        <Button 
                            title={t('scenes.utilities.cubeBackupRestore.buttons.restore')}
                            style={{padding:'0px 8px'}}
                            disabled={!cube || !cube.HasBackup || cube.IDCube === undefined}
                            onClick={()=> !!cube && onRestoreCube(cube.IDCube)}
                            icon='sync'
                            >
                            
                        </Button>
                    </Button.Group>  
                    <Button 
                        title={t('scenes.utilities.cubeBackupRestore.buttons.delete')}
                        style={{padding:'0px 8px', display:'flex', alignItems:'center'}}
                        disabled={!cube || !cube.HasBackup || cube.IDCube === undefined}
                        onClick={()=> !!cube && onDeleteBackupCube(cube.IDCube)}
                        icon="delete">
                                        
                    </Button>  
                </Row>}
                />}
            </Call>       
        </React.Fragment>
    )
}

export default compose(
    translate(),
    connect(mapStateToProps, mapDispatchToProps)
)(BackupRestoreCube);